import React, { Suspense } from 'react'

import { useTranslation } from 'react-i18next'
import { Await, useLoaderData, useNavigation } from 'react-router-dom'

import LoadingMessage from '@components/LoadingMessage'
import PurchasedScoresView from '@components/myScores/PurchasedScoresView'
import LoadingSpinner from '@components/shared/LoadingSpinner'
import { PurchasedLoaderResponse } from '@pages/home/loaders/purchasedScores.loader'
import { usePageTitle } from '@providers/LayoutProvider'

const PurchasedScoresPage: React.FC = () => {
  const { t } = useTranslation()
  const data = useLoaderData() as PurchasedLoaderResponse
  const navigation = useNavigation()

  const isReloading =
    navigation.state === 'loading' &&
    navigation.formData != null &&
    navigation.location.pathname === '/home/purchasedScores'

  usePageTitle(t('titles.purchasedScores'))

  return (
    <>
      {isReloading && <LoadingMessage />}
      <Suspense
        fallback={
          <>
            {/* Spacer */}
            <div className="h-16 w-full" />

            <LoadingSpinner />
          </>
        }>
        <Await resolve={data.purchasedScores}>
          {(purchasedScoresResp) => (
            <PurchasedScoresView initialData={purchasedScoresResp} order={data.order} />
          )}
        </Await>
      </Suspense>
    </>
  )
}

export default PurchasedScoresPage
